import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { PrintWorkChecked } from './ip-board-printwork-dialog.component';
import { Observable } from 'rxjs';
import {
  _post,
  DeserializeVoid,
} from '../../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class SetProjectNeedsPrintworkControllerRequestService {
  private static BASE_URL = '/projects';
  private readonly post: <T>(
    path: string,
    body: any,
    deserialize: (response: any) => T
  ) => Observable<T>;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      SetProjectNeedsPrintworkControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public setProjectNeedsPrintwork(
    projectId: number,
    needPrintwork: boolean,
    printworkExtraInfo: string | null,
    atelierExtraInfo: string | null,
    printWorkChecked: PrintWorkChecked
  ): Promise<void> {
    return this.post(
      '/setNeedsPrintwork',
      {
        projectId,
        needPrintwork,
        printworkExtraInfo,
        atelierExtraInfo,
        printWorkChecked,
      },
      DeserializeVoid
    ).toPromise();
  }
}
